import styled from "styled-components";

const Container = styled.div`
  border-radius: 0.5rem;
  padding: 2rem;
  box-shadow: 0 0 0.7rem 0.5rem rgb(0 0 0 / 0.1);
  margin: 2rem 0;
`;

const Header = styled.h1`
  font-size: 2rem;
  margin: 0 0 2rem 0;
`;

const Message = styled.p`
  font-weight: 700;
  margin: 0;
`;

export const Warning = styled(Container)`
  border: 0.2rem solid ${({ theme }) => theme.colors.orangeWarning};
`;

export const WarningHeader = styled(Header)`
  color: ${({ theme }) => theme.colors.orangeWarning};
`;

export const WarningMessage = styled(Message)`
  color: ${({ theme }) => theme.colors.darkblue};
`;

export const Failure = styled(Container)`
  border: 0.2rem solid ${({ theme }) => theme.colors.darkred};
`;

export const FailureHeader = styled(Header)`
  color: ${({ theme }) => theme.colors.darkred};
`;

export const FailureMessage = styled(Message)`
  color: ${({ theme }) => theme.colors.darkblue};
`;

export const Success = styled(Container)`
  border: 0.2rem solid ${({ theme }) => theme.colors.greenSuccess};
`;

export const SuccessHeader = styled(Header)`
  color: ${({ theme }) => theme.colors.greenSuccess};
`;

export const SuccessMessage = styled(Message)`
  color: ${({ theme }) => theme.colors.darkblue};
`;
